// import contact_panel from '@/components/contact_panel'
import main_page from '@/components/main_page.vue'
import login_page from '@/components/login_page.vue'

export const route_components = {
  '/home': main_page,
  '/login': login_page,
  // '/contact': contact_panel,
}

export const translated_routes = {
  en: {
    '/home': '',
    '/login': '/login',
    // '/contact': '/contact',
  },
  fr: {
    '/home': '',
    '/login': '/login',
    // '/contact': '/contact',
  },
}

function inverse_route_translations() {
  let res = {}
  for (const [language, mapping] of Object.entries(translated_routes)) {
    for (const [canonical_route, translated_route] of Object.entries(mapping)) {
      res['/' + language + translated_route] = canonical_route
    }
  }
  return res
}

function inverse_route_languages() {
  let res = {}
  for (const [language, mapping] of Object.entries(translated_routes)) {
    /* eslint-disable no-unused-vars */
    for (const [canonical_route, translated_route] of Object.entries(mapping)) {
      /* eslint-enable no-unused-vars */
      res['/' + language + translated_route] = language
    }
  }
  return res
}

export const untranslated_routes = inverse_route_translations()
export const routes_to_language = inverse_route_languages()

export function translate_route(canonical_route, language) {
  const res = '/' + language + translated_routes[language][canonical_route]
  return res
}

export function untranslate_route(current_route) {
  const res = untranslated_routes[current_route]
  return res
}

export function language_from_route(current_route) {
  const res = routes_to_language[current_route]
  return res
}

function route_messages_maker() {
  let res = {}
  for (const [language, mapping] of Object.entries(translated_routes)) {
    let tres = {}
    for (const [canonical_route, translated_route] of Object.entries(mapping)) {
      let s = canonical_route
      if (s.length >= 1 && s.charAt(0) === '/') {
        s = s.substr(1)
      }
      s = s.replace('/', '_') + '_link'
      tres[s] = '/' + language + translated_route
      // console.log(s, tres[s])
    }
    res[language] = tres
  }
  // console.log(JSON.stringify(res))
  return res
}

export const i18n_router_messages = route_messages_maker()
